import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { UploadCloudIcon, PaletteIcon, DownloadIcon } from 'lucide-react';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  const steps = [{
    id: '01',
    title: 'Subís tu producto',
    desc: 'Cargá la info básica, copy y branding. El sistema entiende tu oferta.',
    icon: UploadCloudIcon
  }, {
    id: '02',
    title: 'Elegís estilos y ángulos',
    desc: 'Seleccioná entre múltiples ángulos de venta probados psicológicamente.',
    icon: PaletteIcon
  }, {
    id: '03',
    title: 'Descargás tu pack listo',
    desc: 'Obtené 100 creativos optimizados para Meta Ads en minutos.',
    icon: DownloadIcon
  }];
  return <section id="como-funciona" className="py-20 md:py-32 bg-[#0A0A0A] relative" data-id="element-277">
      <div className="container mx-auto px-4" data-id="element-278">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-279">
          <h2 className="text-4xl md:text-6xl font-extrabold mb-6" data-id="element-280">
            La Solución: <span className="text-purple-500" data-id="element-281">100ads</span>
          </h2>
          <h3 className="text-xl md:text-2xl text-gray-400 font-light max-w-3xl mx-auto" data-id="element-282">
            Sistema de Volumen Extremo para productos digitales
          </h3>
        </motion.div>

        {/* Steps Visual */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20" data-id="element-283">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: i * 0.2,
          duration: 0.5
        }} className="glass-card p-8 rounded-3xl relative overflow-visible group" data-id="element-284">
              <div className="absolute right-4 -top-3 text-7xl font-extrabold text-white/[0.05] font-sora group-hover:text-purple-500/10 transition-colors select-none pointer-events-none" data-id="element-285">
                {step.id}
              </div>
              <div className="w-16 h-16 bg-purple-500/10 rounded-2xl flex items-center justify-center mb-6 text-purple-400 border border-purple-500/20 group-hover:scale-110 transition-transform" data-id="element-286">
                <step.icon className="w-8 h-8" data-id="element-287" />
              </div>
              <h4 className="text-2xl font-bold text-white mb-3" data-id="element-288">
                {step.title}
              </h4>
              <p className="text-gray-400 leading-relaxed" data-id="element-289">{step.desc}</p>
            </motion.div>)}
        </div>

        {/* Core Value Prop */}
        <div className="max-w-4xl mx-auto glass-card border-purple-500/30 p-8 md:p-12 rounded-3xl text-center mb-16 bg-gradient-to-b from-purple-900/10 to-transparent" data-id="element-290">
          <p className="text-2xl md:text-4xl font-medium leading-relaxed" data-id="element-291">
            Genera{' '}
            <span className="text-white font-bold" data-id="element-292">
              100 creativos estáticos en ~10 minutos
            </span>
            . <br data-id="element-293" />
            Listos para testear en{' '}
            <span className="text-blue-400 font-bold" data-id="element-294">Meta Ads</span>.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-295">
          {[{
          val: '100+',
          label: 'Creativos'
        }, {
          val: '10 Min',
          label: 'Tiempo Promedio'
        }, {
          val: '5+',
          label: 'Ángulos de Venta'
        }].map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.8
        }} animate={isVisible ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          delay: 0.3 + i * 0.1,
          duration: 0.5
        }} className="text-center p-6 glass-card rounded-2xl" data-id="element-296">
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-b from-white to-purple-400 mb-2 font-sora" data-id="element-297">
                {stat.val}
              </div>
              <div className="text-gray-500 uppercase tracking-widest text-xs font-bold" data-id="element-298">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}